export class MISMOMeasure {
    // Define the MeasureClass enum
    static MeasureClass = {
        None: 0,
        Area: 1,
        Linear: 2,
        Volume: 3
    };

    // Define the MeasureUnits enum
    static MeasureUnits = {
        None: 0,
        Feet: 1,
        Kilometers: 2,
        Meters: 3,
        Miles: 4,
        Yards: 5
    };

    // Constructor
    constructor(_value, _type, _class) {
        this.Value = _value || 0;
        this.Type = _type || null;
        this.Class = _class || MISMOMeasure.MeasureClass.None;
    }

    // Override toString method
    toString() {
        return this.ToString();
    }

    ToString() {
        if (this.Class === MISMOMeasure.MeasureClass.None) return "";
        return `${this.Value} ${this.Type}`;
    }

    HasValue() {
        if (this.Class === MISMOMeasure.MeasureClass.None) return false;
        return true;
    }

    HasNonZeroValue() {
        if (this.Class === MISMOMeasure.MeasureClass.None) return false;
        if (this.Value === 0) return false;
        return true;
    }

    GetValue() {
        return this.Value;
    }
}
